import { Box, Checkbox, Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  name: string;
  role: string;
  checked: boolean;
  onToggle: () => void;
  ariaLabel?: string;
  isExternalGuest?: boolean;
};

export function ExternalGuestLabel() {
  return (
    <Text size="textXs" fw={FONT_WEIGHTS.medium} c="gray.6">
      *external guest
    </Text>
  );
}

export function AttendeeRow({ name, role, checked, onToggle, ariaLabel, isExternalGuest }: Props) {
  return (
    <Flex align="center" gap="sm" py="xxxs">
      <Box style={{ width: 160 }}>
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {name}
        </Text>
        {isExternalGuest && <ExternalGuestLabel />}
      </Box>
      <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.6" style={{ flex: 1 }}>
        {role}
      </Text>
      <Checkbox checked={checked} onChange={onToggle} aria-label={ariaLabel ?? name} />
    </Flex>
  );
}
